package navigation.home.edititinerary

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import cafe.adriel.voyager.core.screen.ScreenKey
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.tab.TabOptions
import cafe.adriel.voyager.transitions.SlideTransition
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource
import navigation.utils.NavLinkTab

class EditItineraryScreenTab(
    val itineraryId: String = "",
) : NavLinkTab {
    private val isConcierge = itineraryId.isEmpty()

    override val key: ScreenKey = "EditItineraryScreenTab/$itineraryId"

    override var innerNavigator: Navigator? by mutableStateOf(null)

    override val options: TabOptions
        @Composable
        get() {
            val title = if (isConcierge) {
                "Concierge"
            } else {
                "Edit Itinerary"
            }
            val icon = esIconPainterResource(
                if (isConcierge)
                    EsIcons.Concierge else
                    EsIcons.Itinerary,
            )
            val index: UShort = 4u

            return TabOptions(
                index, title, icon,
            )
        }

    @Composable
    override fun Content() {
        Navigator(EditItineraryScreenNav(itineraryId)) { navigator ->

            DisposableEffect(navigator) {
                innerNavigator = navigator

                onDispose {
                    innerNavigator = null
                }
            }

            SlideTransition(navigator)
        }
    }
}